import React, { useState } from 'react';
import { XIcon, ShieldCheckIcon } from 'lucide-react';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-[#0f1f2e] border-t border-amber-500/10 py-6 px-6" data-id="element-197">
        <div className="max-w-3xl mx-auto flex flex-col items-center gap-3" data-id="element-198">
          <button onClick={() => setShowPrivacy(true)} className="text-amber-200/50 hover:text-amber-300 text-sm underline underline-offset-4 transition-colors flex items-center gap-2" data-id="element-199">
            <ShieldCheckIcon className="w-4 h-4" data-id="element-200" />
            Política de Privacidad
          </button>
          <p className="text-amber-200/25 text-xs" data-id="element-201">
            © {new Date().getFullYear()} Rutinas Doradas. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {showPrivacy && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-202">
          <div className="bg-[#1a2e40] border border-amber-500/20 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-203">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-amber-500/10" data-id="element-204">
              <h2 className="text-2xl font-serif font-bold text-amber-100 flex items-center gap-3" data-id="element-205">
                <ShieldCheckIcon className="w-6 h-6 text-amber-500" data-id="element-206" />
                Política de Privacidad
              </h2>
              <button onClick={() => setShowPrivacy(false)} className="text-amber-200/50 hover:text-white p-2 rounded-full hover:bg-white/10 transition-colors" aria-label="Cerrar" data-id="element-207">
                <XIcon className="w-6 h-6" data-id="element-208" />
              </button>
            </div>

            {/* Content */}
            <div className="overflow-y-auto p-6 space-y-6 text-amber-100/80 text-lg leading-relaxed" data-id="element-209">
              <p className="text-amber-200/50 text-sm" data-id="element-210">
                Última actualización: Febrero 2026
              </p>

              <section className="space-y-3" data-id="element-211">
                <h3 className="text-xl font-serif font-bold text-amber-200" data-id="element-212">
                  1. Información General
                </h3>
                <p data-id="element-213">
                  En Rutinas Doradas nos comprometemos a proteger tu privacidad.
                  Esta política describe cómo recopilamos, usamos y protegemos
                  tu información personal cuando utilizas nuestro libro digital
                  y servicios relacionados.
                </p>
              </section>

              <section className="space-y-3" data-id="element-214">
                <h3 className="text-xl font-serif font-bold text-amber-200" data-id="element-215">
                  2. Datos que Recopilamos
                </h3>
                <p data-id="element-216">
                  Podemos recopilar la siguiente información cuando accedes a
                  nuestro contenido:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-217">
                  <li data-id="element-218">
                    Dirección de correo electrónico (si te suscribes
                    voluntariamente)
                  </li>
                  <li data-id="element-219">
                    Datos de navegación anónimos para mejorar la experiencia
                  </li>
                  <li data-id="element-220">Preferencias de lectura y progreso dentro del libro</li>
                </ul>
              </section>

              <section className="space-y-3" data-id="element-221">
                <h3 className="text-xl font-serif font-bold text-amber-200" data-id="element-222">
                  3. Uso de la Información
                </h3>
                <p data-id="element-223">Utilizamos tu información exclusivamente para:</p>
                <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-224">
                  <li data-id="element-225">Proporcionarte acceso al contenido adquirido</li>
                  <li data-id="element-226">Mejorar la calidad de nuestros materiales</li>
                  <li data-id="element-227">
                    Enviarte actualizaciones del libro (solo si diste tu
                    consentimiento)
                  </li>
                </ul>
              </section>

              <section className="space-y-3" data-id="element-228">
                <h3 className="text-xl font-serif font-bold text-amber-200" data-id="element-229">
                  4. Protección de Datos
                </h3>
                <p data-id="element-230">
                  Implementamos medidas de seguridad técnicas y organizativas
                  para proteger tu información personal contra acceso no
                  autorizado, pérdida o alteración.
                </p>
              </section>

              <section className="space-y-3" data-id="element-231">
                <h3 className="text-xl font-serif font-bold text-amber-200" data-id="element-232">
                  5. Cookies
                </h3>
                <p data-id="element-233">
                  Nuestro sitio puede utilizar cookies esenciales para el
                  funcionamiento del lector digital. No utilizamos cookies de
                  seguimiento publicitario ni compartimos datos con terceros
                  para fines de marketing.
                </p>
              </section>

              <section className="space-y-3" data-id="element-234">
                <h3 className="text-xl font-serif font-bold text-amber-200" data-id="element-235">
                  6. Tus Derechos
                </h3>
                <p data-id="element-236">
                  Tienes derecho a acceder, rectificar o eliminar tus datos
                  personales en cualquier momento. También puedes retirar tu
                  consentimiento para comunicaciones en cualquier momento.
                </p>
              </section>

              <section className="space-y-3" data-id="element-237">
                <h3 className="text-xl font-serif font-bold text-amber-200" data-id="element-238">
                  7. Cambios en esta Política
                </h3>
                <p data-id="element-239">
                  Nos reservamos el derecho de actualizar esta política de
                  privacidad. Cualquier cambio será publicado en esta misma
                  página con la fecha de actualización correspondiente.
                </p>
              </section>
            </div>

            {/* Footer */}
            <div className="p-6 border-t border-amber-500/10" data-id="element-240">
              <button onClick={() => setShowPrivacy(false)} className="w-full bg-amber-600 hover:bg-amber-500 text-white font-medium py-3 px-6 rounded-xl transition-colors text-lg" data-id="element-241">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </>;
}